import styled from 'styled-components';

interface WrapperProps {
  isExpanded?: boolean;
}

export const Wrapper = styled.div<WrapperProps>`
  display: flex;
  padding: 8px 12px;
  border-radius: 8px;
  background: ${({ theme }) => theme.palette.bg700};
  ${({ theme }) => theme.typography('$body_02')};
`;

export const Contents = styled.div`
  width: 100%;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const Badge = styled.div<WrapperProps>`
  display: flex;
  flex: 0 0 24px;
  margin-right: 8px;
  color: #e13a3a;
  ${({ theme }) => theme.typography('$body_03')};
`;

export const ButtonClose = styled.button<WrapperProps>`
  flex: 0 0 20px;
  width: 20px;
  height: 20px;
`;

export const CheckboxWrapper = styled.div`
  margin-top: 16px;
`;
